import getProducts from './getProducts';
import getProduct from './getProduct';
import postProduct from './postProduct';

export default {
  getProducts,
  getProduct,
  postProduct,
};



// WEBPACK FOOTER //
// ./src/api/products/actions/index.js